define('views/modules/template/edit/form/template-form',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    'services/i18n',
    'services/user',
    'services/toastr-service',
    // views
    'views/parts/form/textbox',
    'views/parts/form/choices',
    // templates
    'text!templates/modules/template/edit/form/template-form.html'
], function(
    // libs
    _, Backbone, Mustache, U, i18n, User, ToastrService,
    // views
    VTextbox,
    VChoices,
    // templates
    TTemplateForm
) {

    var VTemplateForm = Backbone.View.extend({
        template: TTemplateForm,

        regions: {
            name: '.name-input',
            sharedToSubgroups: '.share-input'
        },

        initialize: function(opt) {
            this.options = opt || {};

            var model = this.model,
                view = this.view = {
                    name: new VTextbox({ label: 'Name', attribute: 'name', labelposition: 'outer', model: model }),
                    sharedToSubgroups: new VChoices({ label: "Share this template to all sub-groups", attribute: "sharedToSubgroups", model: this.model, context: this, onChange: this.onChange }),
                };
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.name, zone.$name)
                .assign(view.sharedToSubgroups, zone.$sharedToSubgroups);
        },

        setDisabled: function(disabled) {
            this.zone.$name.find('input').prop('disabled', disabled);
            this.zone.$sharedToSubgroups.find('input').prop('disabled', disabled);
        },

        ////////////
        // events //
        ////////////

        onChange: function() {
            if (this.model.get('owner') !== User.id && ! this.model.isNew()) {
                ToastrService.error('template:you-cannot-share-because-dont-own-it');
                this.model.set('sharedToSubgroups', this.model.previous('sharedToSubgroups'));
            }

            return true;
        }

    });

    return VTemplateForm;

});

